export default __webpack_public_path__ + "static/media/DAO.003c6a87.svg";